import * as Constants from './constants'

export const nguoiDungKhoListRequest = function nguoiDungKhoListRequest(formData) {
  return {
    type: Constants.NGUOIDUNGKHO_LIST_REQUESTING,
    payload: formData
  }
}

export const nguoiDungKhoListSuccess = function nguoiDungKhoListSuccess(data) {
  return {
    type: Constants.NGUOIDUNGKHO_LIST_SUCCESS,
    data
  }
}

export const nguoiDungKhoListError = function nguoiDungKhoListError(error) {
  return {
    type: Constants.NGUOIDUNGKHO_LIST_ERROR,
    error
  }
}

export const nguoiDungKhoDetailRequest = function nguoiDungKhoDetailRequest(formData) {
  return {
    type: Constants.NGUOIDUNGKHO_DETAIL_REQUESTING,
    payload: formData
  }
}

export const nguoiDungKhoDetailSuccess = function nguoiDungKhoDetailSuccess(data) {
  return {
    type: Constants.NGUOIDUNGKHO_DETAIL_SUCCESS,
    data
  }
}

export const nguoiDungKhoDetailError = function nguoiDungKhoDetailError(error) {
  return {
    type: Constants.NGUOIDUNGKHO_DETAIL_ERROR,
    error
  }
}

export const nguoiDungKhoUpdateRequest = (formData, callback) => {
  return {
    type: Constants.NGUOIDUNGKHO_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const nguoiDungKhoUpdateSuccess = function nguoiDungKhoUpdateSuccess(response) {
  return {
    type: Constants.NGUOIDUNGKHO_UPDATE_SUCCESS,
    payload: response
  }
}

export const nguoiDungKhoUpdateError = function nguoiDungKhoUpdateError(error) {
  return {
    type: Constants.NGUOIDUNGKHO_UPDATE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/NguoiDungKho/actions.js